import { render, staticRenderFns } from "./StudyQuizModal.vue?vue&type=template&id=3c8503cb"
import script from "./StudyQuizModal.vue?vue&type=script&lang=js"
export * from "./StudyQuizModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports